import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PredectionListState {
  processId: number;
  docTypeId: string;
}

const initialState: PredectionListState = {
  processId: 0,
  docTypeId: ''
};

const PredectionListSlice = createSlice({
  name: 'PredectionList',
  initialState: initialState,
  reducers: {
    setPredectionListProcessID(state, action: PayloadAction<number>) {
      state.processId = action.payload;
    },
    setPredectionListDocumentId(state, action: PayloadAction<string>) {
      state.docTypeId = action.payload;
    },
    setPredectionListData(state, action: PayloadAction<{ processId: number; docTypeId: string }>) {
      state.docTypeId = action.payload.docTypeId;
      state.processId = action.payload.processId;
    },
    clearPredectionData(state) {
      state.docTypeId = '';
      state.processId = 0;
    }
  }
});

export const { setPredectionListProcessID, setPredectionListDocumentId, setPredectionListData, clearPredectionData } =
  PredectionListSlice.actions;

export default PredectionListSlice.reducer;
